import { render, staticRenderFns } from "./DecisionStage.vue?vue&type=template&id=52266d42&scoped=true"
import script from "./DecisionStage.vue?vue&type=script&lang=js"
export * from "./DecisionStage.vue?vue&type=script&lang=js"
import style0 from "./DecisionStage.vue?vue&type=style&index=0&id=52266d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52266d42",
  null
  
)

export default component.exports